import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Peeshkot - cookie warnings, go away!",
  "description": "",
  "published": "2013-06-19T00:00:00.000Z",
  "redirect_from": ["/blog/peeshkot-cookie-warnings-go-away/swizec/6242"],
  "categories": "Cookie, European Union, Google Analytics, HTTP cookie, Slovenia, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/nUpYuoErSieYKXEEti7b",
        "alt": null
      }}></img></p>
    <p>{`While the `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=39.109,-76.77&spn=0.01,0.01&q=39.109,-76.77%20(National%20Security%20Agency)&t=h",
        "title": "National Security Agency"
      }}>{`NSA`}</a>{` has been spying on our every move for years, recording hundreds of private phone calls in the US and archiving `}<a parentName="p" {...{
        "href": "http://www.wsws.org/en/articles/2013/06/17/nsap-j17.html"
      }}>{`"virtually all internet usage, everywhere"`}</a>{` the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/European_Union",
        "title": "European Union"
      }}>{`European Union`}</a>{` passed a directive in 2009 about `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/HTTP_cookie",
        "title": "HTTP cookie"
      }}>{`internet cookies`}</a>{`.`}</p>
    <p>{`Until 2011 all member states were required to pass laws saying that when websites use cookies they should ask permission. Only three states met the deadline and of those one said `}<em parentName="p">{`"Fuck this, everyone, chill. The law is here, but you have like a year to comply. All's good."`}</em>{`. That was the UK.`}</p>
    <p>{`I can't find a source saying which of the 27 EU countries have passed the cookie law, but on June 15th `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.05,14.5&spn=10.0,10.0&q=46.05,14.5%20(Slovenia)&t=h",
        "title": "Slovenia"
      }}>{`Slovenia`}</a>{` has become one of those countries annoying its internet users. This affects me. I don't like that.`}</p>
    <p>{`First thing I heard on the morning of the 16th was my mum rushing into my room `}<em parentName="p">{`"OMG, what is this cookie thing? Chrome is trying to install a cookie? What the hell is going on?"`}</em></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/statuses/346262949217828864"
      }}>{`https://twitter.com/Swizec/statuses/346262949217828864`}</a></p>
    <p>{`On a Sunday morning nobody should have to explain what is a cookie and that it isn't the end of the world to a distraught technically impaired parent. Nobody.`}</p>
    <h2 {...{
      "id": "peeshkot"
    }}>{`Peeshkot`}</h2>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/p0gQmwoMRbqgjKkogBwN",
        "alt": "Peeshkot icon by @ponywithhiccups",
        "title": "Peeshkot icon by @ponywithhiccups"
      }}></img><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img></p>
    <p>{`So `}<a parentName="p" {...{
        "href": "https://twitter.com/eewan"
      }}>{`@eewan`}</a>{` and I made a solution - `}<a parentName="p" {...{
        "href": "https://chrome.google.com/webstore/detail/peeshkot/idfkeeahcifaocjonphgjmpmmfonahle"
      }}>{`Peeshkot`}</a>{`. Instal Peeshkot extension in your `}<a parentName="p" {...{
        "href": "http://https://www.google.com/chrome",
        "title": "Google Chrome"
      }}>{`Chrome browser`}</a>{` and all cookie notices will be gone.`}</p>
    <p>{`It will recognise most common implementations and make them go away, or opt-in if necessary. @eewan even made sure it will recognise most homegrown implementations with the use of some clever heuristics.`}</p>
    <p>{`Especially recommended for your parents and grandparents and people with short tempers in regards to popups and flashing things.`}</p>
    <p>{`We plan to add opt-out support in the near future. Although why you wouldn't just block third party cookies if you want that sort of thing is beyond me.`}</p>
    <p>{`Did I mention `}<a parentName="p" {...{
        "href": "https://chrome.google.com/webstore/detail/peeshkot/idfkeeahcifaocjonphgjmpmmfonahle"
      }}>{`Peeshkot`}</a>{` is open source? You can submit issues and generally `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/Peeshkot"
      }}>{`help out on Github`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=95b746e3-f532-49e2-9273-5460d93d564a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      